import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    message: null,
    messageType: null
}

export const commonReducer = createSlice({
    name: 'common',
    initialState,
    reducers: {
        successMessage: (state, action) => {
            state.message = action.payload;
            state.messageType = "Success";
        },
        errorMessage: (state, action) => {
            state.message = action.payload
            state.messageType = "Error";
        },
        clearMessage: (state, action) => {
            state.message = null
            state.messageType = null
        }
    },
})

// Action creators are generated for each case reducer function
export const { successMessage, errorMessage, clearMessage } = commonReducer.actions

export default commonReducer.reducer;